import Icons from '@/shared/components/icon/Icons'

function CurrentPositionMarker() {
  return (
    <div className="translate-x-[-50%] translate-y-[-100%]">
      <div className="relative flex h-[34px] flex-col items-center">
        <Icons.PositionIcon />
      </div>
      <div className="absolute bottom-[1px] left-[10.5px] h-[6px] w-[12px]">
        <Icons.PinShadowIcon />
      </div>
    </div>
  )
}

function ParkinglotPositionMarker() {
  return (
    <div className="translate-x-[-50%] translate-y-[-100%]">
      <div className="flex h-[32px] w-[32px] items-center">
        <Icons.ParkinglotLocationIcon />
      </div>
    </div>
  )
}

function CurrentLocationButton() {
  return (
    <button type="button" className="z-1 m-[16px] h-[36px] w-[36px] rounded-full bg-gray-010 shadow-md">
      <div className="flex h-full w-full items-center justify-center">
        <Icons.GpsIcon stroke="currentColor" color="#263238" />
      </div>
    </button>
  )
}

function ParkinglotLocationButton() {
  return (
    <button type="button" className="z-1 m-[16px] h-[36px] w-[36px] rounded-full bg-gray-010 shadow-md">
      <div className="flex h-full w-full items-center justify-center">
        <Icons.LocationIcon stroke="currentColor" color="#263238" />
      </div>
    </button>
  )
}

function AirportMarker() {
  return (
    <div className="relative translate-x-[-50%] translate-y-[-100%]">
      <div className="relative flex cursor-pointer flex-col items-center justify-center gap-1 rounded-md border border-b-0 bg-main-070 px-2 pb-[6px] pt-2 text-center">
        <Icons.AirportIcon />
        <p className="text-[9px] font-bold text-white">공항 주차</p>
        <div className="absolute bottom-[-9px] left-1/2 h-0 w-0 translate-x-[-50%] border-x-[7px] border-t-[10px] border-x-transparent border-t-main-070" />
      </div>
      <div className="absolute bottom-[-12px] left-1/2 h-[6px] w-[12px] translate-x-[-50%]">
        <Icons.PinShadowIcon />
      </div>
    </div>
  )
}

export default {
  CurrentPositionMarker,
  ParkinglotPositionMarker,
  CurrentLocationButton,
  ParkinglotLocationButton,
  AirportMarker
}
